/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef } from "react";
import { useApp } from "../../../../appContext";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { LeftMenuItems } from "../../../../config/leftMenuItems";
import { DashboardItems } from "../../../../config/dashboard";
import FadeIn from "react-fade-in/lib/FadeIn";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";

const BrudCrubs = (props: any) => {
  const { endNode } = props;
  const appContext = useApp();
  const { t } = useTranslation();
  type MenuItem = {
    item: string;
    path: string;
    displayName: string;
    icon: Element;
    permission: string;
  };

  type LeftMenuItemsType = {
    control: MenuItem[];
    system: MenuItem[];
    fax: MenuItem[];
    settings: MenuItem[];
  };

  const userApps = [
    "users",
    "calllogs",
    "SIP Accounts",
    "Cell Phones",
    "voicemail",
  ];

  const navigate = useNavigate();
  const navigation = useLocation();
  const [menuItems, setMenuItems] = useState<any>([]);
  const [activeIndex, setActiveIndex] = useState<number>(-1);
  const [brudcrubs, setBrudcrubs] = useState<any>([
    { display: "home", path: "home" },
  ]);
  const userSettings = useSelector(
    (state: RootState) => state?.Auth?.userSettings
  );

  const { routes } = appContext;
  const { loggedUserRoles } = useSelector((state: any) => state.Auth);
  const { apps } = useSelector((state: RootState) => state.Auth);

  const isUser =
    userSettings?.roles_l?.length === 1 && userSettings?.roles_l[0] === "user";
  const getAccountDetails = () => {
    const currentAccount: any = window.localStorage.getItem("currentAccount");
    let value = JSON.parse(currentAccount);
    return value;
  };

  const navigateTo = (nav: any, index: number) => {
    let path = nav;
    if (nav?.basePath) {
      path = nav?.basePath;
    } else if (nav?.path) {
      path = nav?.path;
    } else if (nav?.item) {
      path = nav?.item;
    }
    let result: any = [];
    if (index === 0) {
      navigate(`/bvoice/${path}`, { replace: true });
      setMenuItems([]);
      setActiveIndex(-1);
    } else if (index === 1) {
      const accType = getAccountDetails().type;
      console.log("typesss", getAccountDetails(), apps);
      if (apps?.length === 0) {
        result = [];
        setMenuItems(result);
      } else if (apps?.length !== 0 && accType) {
        loggedUserRoles.forEach((role: any) => {
          DashboardItems.forEach((node: any) => {
            if (
              node?.permissions?.includes(
                role?.name === "agent" ? "tenant_admin" : role?.name
              )
            ) {
              result.push(node);
            }
          });
        });
        result?.filter((node: any) => apps?.includes(node?.item));
        console.log("resss", result);
        setMenuItems(result);
      } else if (!accType) {
        console.log("appssss", loggedUserRoles, DashboardItems);
        apps?.forEach((role: any) => {
          DashboardItems.forEach((node: any) => {
            if (
              role.split("_")[0]
                ? role.split("_")[0] === node?.item
                : role === node?.item
            ) {
              result.push(node);
            }
          });
        });

        console.log("resss", result);
        setMenuItems(result);
      } else {
        loggedUserRoles.forEach((role: any) => {
          DashboardItems.forEach((node: any) => {
            if (
              node?.permissions?.includes(
                role?.name === "agent" ? "tenant_admin" : role?.name
              )
            ) {
              result.push(node);
            }
          });
        });
        setMenuItems(result);
      }
      setActiveIndex(index);
    }
    // else if (index === 2 && LeftMenuItems[brudcrubs[1].path as "control" || 'system' || 'fax' || "settings"]) {
    //     setMenuItems(LeftMenuItems[brudcrubs[1].path as "control" || 'system' || 'fax' || "settings"])
    //     setActiveIndex(index)
    // }
    else if (
      index === 2 &&
      ["control", "system", "fax", "settings", "supervisor"].includes(
        brudcrubs[1].path
      )
    ) {
      const selectedPath = brudcrubs[1].path as keyof LeftMenuItemsType;
      setMenuItems(LeftMenuItems[selectedPath]);
      setActiveIndex(index);
    }
  };

  function contains(target: any, pattern: any) {
    let value = 0;
    pattern.forEach(function (word: any) {
      value = value + target.includes(word);
    });
    return value === 1;
  }
  useEffect(() => {
    let parent: any = navigation.pathname.split("/");
    parent = parent.filter((path: any) => path !== "");
    let path = [{ display: "home", path: "home" }];
    let key: string = "";
    // eslint-disable-next-line array-callback-return
    parent.map((node: any, index: number) => {
      key = key + "/" + node;
      key = key.replace("/bvoice", "");
      const item = routes.find((route) => route.path === key);
      if (item) {
        path.push({ display: item.title, path: item.path.slice(1) });
      } else if (
        !contains(node, [
          "-",
          "new",
          "edit",
          "pbx",
          "id",
          "tab",
          "add",
          "bvoice",
        ])
      ) {
        if (index <= 2) {
          node = node.includes("_") ? node.replace(/_/g, " ") : node;

          path.push({ display: node, path: "" });
        } else {
          node = node.includes("_") ? node.replace(/_/g, " ") : node;
          path.push({ display: node, path: "" });
        }
      }
    });
    setBrudcrubs([...path]);
  }, [navigation.pathname]);

  const wrapperRef: any = useRef(null);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setMenuItems([]);
        setActiveIndex(-1);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [wrapperRef]);
  console.log(
    "arrayIsArray",
    // brudcrubs,
    menuItems,
    // userApps,
    // activeIndex,
    apps?.map((node) => {
      return node?.includes("_") ? node?.replaceAll("_", "") : node;
    })
  );
  return (
    <div ref={wrapperRef}>
      <ol className="max-md:pl-10 flex p-4 items-center w-full space-x-3 text-sm font-medium text-center text-gray-500 bg-white ">
        {brudcrubs.map((brudcrub: any, index: number) => {
          return (
            <li
              id={brudcrub?.display + index}
              key={index}
              onClick={() => navigateTo(brudcrub.path, index)}
              className={`flex relative capitalize items-center ${
                brudcrubs.length - 1 !== index || endNode !== ""
                  ? "max-md:hidden text-primary"
                  : "text-ternary-text"
              } cursor-pointer`}
            >
              {brudcrub.display === "ivr"
                ? "IVR"
                : brudcrub.display === "sla"
                  ? "SLA"
                  : brudcrub.display === "sip accounts"
                    ? "SIP Accounts"
                    : brudcrub?.display}
              {(brudcrubs.length - 1 !== index || endNode !== "") && (
                <svg
                  aria-hidden="true"
                  className=" w-4 h-4 ml-2 sm:ml-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M13 5l7 7-7 7M5 5l7 7-7 7"
                  ></path>
                </svg>
              )}
              {index === activeIndex && (
                <div className="absolute h-auto w-[200px]  text-primary border border-primary-alpha-20 bg-ternary text-left p-0 -ml-6 top-[28px] z-10">
                  <FadeIn>
                    {menuItems
                      // ?.filter((node: any) => {
                      //   if (isUser) {
                      //     return node;
                      //   } else {
                      //     return node;
                      //   }
                      // })
                      .map((item: any, index: number) => {
                        return (
                          <div
                            id={item?.item}
                            key={item.item}
                            onClick={() => navigateTo(item, 0)}
                            className="px-4 py-2 cursor-pointer hover:bg-primary-alpha-20 "
                          >
                            {t(item.displayName)}
                          </div>
                        );
                      })}
                  </FadeIn>
                </div>
              )}
            </li>
          );
        })}

        {endNode
          ? Array.isArray(endNode)
            ? endNode.map((node, idx) => {
                return (
                  <>
                    <li
                      className={`flex capitalize items-center max-w-[240px] text-ellipsis whitespace-nowrap overflow-hidden text-ternary-text`}
                    >
                      {t(node)}
                    </li>
                    {endNode.length - 1 !== idx && (
                      <svg
                        aria-hidden="true"
                        className=" w-4 h-4 ml-2 sm:ml-4"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M13 5l7 7-7 7M5 5l7 7-7 7"
                        ></path>
                      </svg>
                    )}
                  </>
                );
              })
            : endNode !== "" && (
                <li
                  className={`flex capitalize items-center max-w-[240px] text-ellipsis whitespace-nowrap overflow-hidden text-ternary-text`}
                >
                  {t(endNode)}
                </li>
              )
          : ""}
      </ol>
    </div>
  );
};
export default BrudCrubs;
